import { PARTNER_SLUG } from '@/shared/lib/partner';

/**
 * Значки заказчика.
 *
 * Значки рисует дизайнер вместе с макетом, и у разных заказчиков они разные:
 * крестик ФОСИ тоньше и крупнее нашего. Пока путь к файлу был вшит в кнопку,
 * в витрине заказчика всплывали наши значки — чаще всего там, где человек
 * их не ждёт: в окне размерной сетки, в пустой корзине.
 *
 * Поэтому набор значков — данные, как тема и сценарий. Компонент просит
 * значок по имени и не знает, чей он.
 */
export type IconName = 'arrow' | 'cart' | 'close' | 'plus';

const DEFAULT: Record<IconName, string> = {
  arrow: '/ui/arrow.svg',
  cart: '/ui/cart.svg',
  close: '/ui/cross.svg',
  plus: '/ui/plus.svg',
};

const FOSY: Record<IconName, string> = {
  arrow: '/fosy/arrow.svg',
  cart: '/fosy/cart.svg',
  close: '/fosy/close.svg',
  plus: '/fosy/plus.svg',
};

/**
 * СИЯЙ: тот же рисунок, что в общем наборе, но чёрный.
 *
 * Общий набор золотой — он рисовался под тёмную витрину
 * effective-records. На белом полотне СИЯЙ золотая корзина выглядит
 * случайным цветным пятном: других цветных пятен на экране нет вовсе.
 *
 * Плюс белый, а не чёрный: он один стоит на чёрной кнопке. Цвет значка
 * задаётся не набором, а тем, на чём значок лежит.
 */
const SIYAI: Record<IconName, string> = {
  arrow: '/siyai/arrow.svg',
  cart: '/siyai/cart.svg',
  close: '/siyai/close.svg',
  plus: '/siyai/plus.svg',
};

const SETS: Record<string, Record<IconName, string>> = {
  fosy: FOSY,
  siyai: SIYAI,
};

const SET = SETS[PARTNER_SLUG] ?? DEFAULT;

export function icon(name: IconName): string {
  return SET[name];
}
